import { Content, Part, Schema } from '@google/genai';
import { DocumentChunkSource, PccDataSource } from './source.typings';

export class SerenaChatResponse {
	answer: string;

	sources: DocumentChunkSource[];

	pccSources: PccDataSource[];

	pccAccessRestrictions: PccDataSource[];

	sortedSources: Array<DocumentChunkSource | PccDataSource>;

	constructor(partial?: Partial<SerenaChatResponse>) {
		Object.assign(this, partial);
		this.sources = this.sources?.map((source) => new DocumentChunkSource(source)) || [];
		this.pccSources = this.pccSources?.map((source) => new PccDataSource(source)) || [];
		this.sortedSources = [...this.sources, ...this.pccSources].filter((source) => source.distance).sort((a, b) => b.distance - a.distance);
	}
}

export class SerenaChatMessage {
	messageId: string;

	fullPrompt? = '';

	prompt? = '';

	response?: SerenaChatResponse;

	promptTimestamp?: Date;

	responseTimestamp?: Date;

	loading = false;

	senderId? = '';

	senderName? = '';

	facilityId? = '';

	patientId? = '';

	error?: boolean;

	errorMessage?: string;

	aiGeneratedRagPrompt?: { rewrittenQuery: string };

	pccAccessRestrictions?: PccDataSource[];

	constructor(partial?: Partial<SerenaChatMessage>) {
		Object.assign(this, partial);
		['promptTimestamp', 'responseTimestamp'].forEach((key) => {
			if (this[key]?.toDate) {
				this[key] = this[key].toDate();
			}
		});
		if (this.response) {
			this.response = new SerenaChatResponse(this.response);
		}
	}
}

export interface QueryGeminiTaskData {
	docPath: string;
	attachmentPaths?: string[];
	maxAttachmentPages?: number;
	requestKey?: string;
	responseMimeType?: string;
	model?: string;
	temperature?: number;
	topP?: number;
	topK?: number;
	maxOutputTokens?: number;
	stopSequences?: string[];
	responseSchema?: Schema;
	systemInstruction?: { role: string; parts: Part[] };
	categories?: string[];
	findingNameOptions?: string[];
	instructions?: string;
	requestContents?: Content[];
	responseType?: 'json' | 'text';
	saveResponseField?: string;
}
